var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_top"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"left_item"},[_c('h3',[_c('br'),_vm._v(_vm._s(_vm.$t('homeTop.h3Title1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('homeTop.desc')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }